import { render, staticRenderFns } from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=template&id=0affa742&scoped=true"
import script from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=style&index=0&id=0affa742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affa742",
  null
  
)

export default component.exports